// import { FACEBOOK_APP_ID } from '@/config';
// import VueFacebook from '@p803/vue-facebook';
// import Vue from 'vue';

// Vue.use(VueFacebook, {
//     appId: FACEBOOK_APP_ID,
//     version: 'v6.0',
//     xfbml: true,
// });
